<div class="container">
  <div class="publish-date-area">
    <label class="publish-date">
      {{model.publishDate}}
    </label>
    <img *ngIf="model.buyerRecommendFlag" src="assets/images/newitem-2@2x.png" width="110.5px" height="17.5px"
      class="buyer-recommend-img">
  </div>
  <div class="carousel-area">
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of model.imageList" class="slide">
        <img [src]="image" alt="" width="100%">
      </div>
    </ngx-slick-carousel>
  </div>
  <div class="title-area">
    <div *ngIf="model.releaseDate">
      <label class="release-date">
        {{model.releaseDate}}
      </label>
    </div>
    <div>
      <label class="title">
        {{model.title}}
      </label>
    </div>
  </div>
  <div class="hr-area-title">
    <hr class="hr">
  </div>
  <div *ngIf="model.buyerRecommendFlag" class="buyer-recommend-point-area">
    <img src="assets/images/newitem-3@2x.png" width="153.5px" height="17.5px" class="buyer-recommend-point-img">
  </div>
  <!-- バイヤーおススメWYSIWYG -->
  <div *ngIf="model.buyerRecommendFileName" class="buyer-reccomend-wysiwyg">
    <div [innerHTML]='buyerCommentBody'></div>
  </div>
  <div *ngIf="model.buyerRecommendFileName" class="hr-area">
    <hr class="hr">
  </div>
  <!-- 商品説明WYSIWYG -->
  <div *ngIf="model.clientFileName" class="item-discription-wysiwyg">
    <div [innerHTML]='itemDiscriptionBody'></div>
  </div>
  <div class="hr-area">
    <hr class="hr">
  </div>
  <div>
    <label class="maker">
      {{model.maker}}
    </label>
  </div>
  <div>
    <label class="brand">
      {{model.brand}}
    </label>
  </div>
  <!-- 売価WYSIWIG -->
  <div *ngIf="model.priceFileName" class="price-discription-wysiwyg">
    <div [innerHTML]='priceDiscriptionBody'></div>
  </div>
  <div *ngIf="model.makerSite" class="maker-site-area">
    <label class="maker-site-label">
      ▼公式サイト
    </label>
  </div>
  <div *ngIf="model.makerSite" class="maker-site-url-area">
    <a class="maker-site" href="#" (click)="openMakerSite(model.makerSite)">詳しくはこちら</a>
  </div>
  <div *ngIf="storeInfoVisible" class="hr-area">
    <hr class="hr">
  </div>
  <!-- <div class="sns-area">
    <a
      href="https://twitter.com/intent/tweet?text={{model.title}}&url=http%3A%2F%2Fdev-ain-mobile-app-webview.s3-website-ap-northeast-1.amazonaws.com%2F%23%2Fitem-detail%3FitemId%3D26%26clientId%3Drohto&hashtags=ainztulpe,アインズトルペ">
      <img src="../../assets/images/Twitter_Social_Icon_Circle_Color.png" height="30px" width="30px">
    </a>
    <span class="line-area">
      <div class="line-it-button" data-lang="ja" data-type="share-c" data-ver="3"
        data-url="https://media.line.me/ja/how_to_install#lineitbutton" data-color="default" data-size="small"
        data-count="false" style="display: none;"></div>
    </span>
  </div> -->
  <div class="store-title-area" *ngIf="storeInfoVisible">
    <label id="store-title" class="store-title">取り扱い店舗</label>
  </div>
  <div *ngIf="storeInfoVisible">
    <mat-accordion #myaccordion="matAccordion" multi="true">
      <mat-expansion-panel *ngFor="let storeInfo of storeInfoList">
        <mat-expansion-panel-header class="category" [expandedHeight]="'50px'">
          <label class="category-label">{{storeInfo.area}}</label>
        </mat-expansion-panel-header>
        <div *ngFor="let store of storeInfo.stores; index as i">
          <mat-panel-description [class.header]="storeInfo.stores.length > i + 1"
            [class.header-last]="i + 1 == storeInfo.stores.length" (click)="openAppStoreDetail(store.deepLinkUrl)">
            <label class="store-name">
              {{store.name}}
            </label>
            <img src="assets/images/arrow_right.svg">
          </mat-panel-description>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div *ngIf="storeInfoVisible">
    <hr class="hr">
  </div>
  <div *ngIf="storeInfoVisible" class="warn-area">
    <div>
      <label class="warn">
        ※休業日、営業時間については各店舗までお問合わせください。
      </label>
    </div>
    <div>
      <label class="warn">
        ※店舗により売り切れの場合がございます。
      </label>
    </div>
  </div>
</div>